export function getCountryFromUrl () {
  let countryLang = getCountryAndLanguagePathFromUrl(),
      countryLangArr = countryLang.split('-');

  return countryLangArr[0];
}

export function getCountryId () {
  let country = getCountryFromUrl();

  switch(country) {
    case 'ch':
      return 2;
    case 'at':
      return 3;
    case 'lu':
      return 4;
    default:
      return 1;
  }
}

export function getLanguageFromUrl () {
  let countryLang = getCountryAndLanguagePathFromUrl(),
      countryLangArr = countryLang.split('-');

  return countryLangArr[1];
}

export function getCountryAndLanguagePathFromUrl () {
  let path = window.location.pathname,
      pathArr = path.split('/'),
      cleanPath = pathArr.filter(function (el) {return el !== ''});

  return cleanPath[0];
}

export function getURLParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function checkCookies() {
  let cookieEnabled = navigator.cookieEnabled;
  if (!cookieEnabled) {
    document.cookie = "cookies_allowed";
    cookieEnabled = document.cookie.indexOf("cookies_allowed") !== -1;
    document.cookie = 'cookies_allowed; expires=Thu, 01-Jan-1970 00:00:01 GMT';
  }
  return cookieEnabled;
}

export function setCookie(cname, cvalue, exdays) {
  if (checkCookies()) {
    let d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = 'expires=' + d.toUTCString();

    document.cookie = cname + '=' + cvalue + '; ' + expires + '; path=/; samesite=strict';
  } else {
    console.warn('Cookies are disabled');
  }
}

export function getCookie(cname) {
  if (checkCookies()) {
    let name = cname + '=',
        ca = document.cookie.split(';');
    for (let c of ca) {
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  } else {
    console.warn('Cookies are disabled');
  }
}

export function removeCookie(cname) {
  setCookie(cname, '', -1);
}

export function getBrowser () {
  let ua= navigator.userAgent, tem,
      M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if(/trident/i.test(M[1])){
    tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
    return 'IE '+(tem[1] || '');
  }
  if(M[1]=== 'Chrome'){
    tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
    if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
  }
  M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
  if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
  return M.join(' ');
}